<div class="version-status" *ngIf="pageStatus == STATUS_DONE">
    <div class="status">
        <core-helpers-forms-select
        [optionSelected]="currentStatus.id.toString()"
        [label]="'This Artwork is'"
        [options]="availableStatus"
        (select)="onStatusMenuSelect($event)"
        ></core-helpers-forms-select>
    </div>
</div>
